import moment from 'moment'
import { message as $message } from 'antd'
import { getStore } from '@/utils/dva'
import { getSignatureInfo, getUploadAddressAndCredentials, getShareSignature } from '@/services/alioss'
import upload from '@/utils/upload'
import { getUUID } from '@/utils/utils'
import { captureException } from '@/utils/track'
import { isVideo } from './utils'

// 签名控制器
class SignatureControl {
    signature = null
    getSignatureApi = getSignatureInfo

    _resolve = null
    _reject = null

    lock() {
        if (!this._resolve) {
            this._p = new Promise((resolve, reject) => {
                this._resolve = resolve
                this._reject = reject
            })
        }
    }

    unlock() {
        if (this._resolve) {
            this._resolve()
            this.clear()
        }
    }

    clear() {
        this._p = this._resolve = this._reject = null
    }

    static enqueueIfLocked(promise) {
        if (promise) {
            return promise
        }

        return Promise.resolve()
    }

    async refreshSignature() {
        try {
            const { success, data, now } = await this.getSignatureApi()

            if (success) {
                const expire = Date.now() + (data.expire - now) - 2 * 60 * 1000 // 过期时间提前2分钟

                this.signature = {
                    ...data,
                    expire
                }
            } else {
                this.signature = null
            }
        } catch (e) {
            console.error('catchError', e)
        }
    }

    checkSignature() {
        const { expire } = this.signature

        return Number(expire) >= Date.now()
    }

    async retry(count) {
        this.lock()

        for (let i = 0; i < count; i++) {
            if (!this.signature || !this.checkSignature()) {
                await this.refreshSignature()
            } else {
                break
            }
        }

        this.unlock()
    }

    async getSignature() {
        await SignatureControl.enqueueIfLocked(this._p)

        if (!this.signature || !this.checkSignature()) {
            await this.retry(1)
        }

        return this.signature
    }
}

class ShareSignatureControl extends SignatureControl {
    constructor() {
        super()
        this.getSignatureApi = getShareSignature
    }
}

const signatureCtrl = new SignatureControl()
const shareSignatureCtrl = new ShareSignatureControl()

// temp为临时文件目录
// eslint-disable-next-line complexity
export default async ({
    fileDirectory,
    isTranscoder,
    temp = false,
    file,
    fileSuffix = '',
    onProgress,
    onSuccess,
    onError,
    shareSignature = false
}) => {
    onProgress && onProgress({ percent: 0 })
    let data = {}

    if (isVideo(file) && isTranscoder) {
        const { currentUser } = getStore().getState().user
        if (!fileDirectory) {
        }
        const params = {
            fileName: file.name,
            tags: `${fileDirectory},${currentUser?.coId}`,
            coId: currentUser?.coId || -1
        }
        const res = await getUploadAddressAndCredentials(params)
        data = res.data
    } else {
        let ctrl = shareSignature ? shareSignatureCtrl : signatureCtrl
        data = await ctrl.getSignature()
    }

    if (data) {
        const { dir, accessId, host, policy, signature, ossUrlDomain, expire } = data

        const suffix = fileSuffix || file.name.slice(file.name.lastIndexOf('.'))

        const { source = {}, width = 0, height = 0 } = file || {}
        const { type = '', size = 0 } = source

        const IS_IMAGE = type.indexOf('image/') !== -1
        const IS_IMAGE_VALID = IS_IMAGE && !(!size || !width || !height)

        let key = ''

        if (IS_IMAGE_VALID) {
            key = temp
                ? `${dir}tmp/${getUUID()}_s${size}_h${height}_w${width}${suffix}`
                : `${dir}${fileDirectory || 'front'}/${getUUID()}_s${size}_h${height}_w${width}${suffix}`
        } else {
            key = temp
                ? `${dir}tmp/${getUUID() + Date.now()}${suffix}`
                : `${dir}${fileDirectory || 'front'}/${getUUID() + Date.now()}${suffix}`

            // 如果是图片但是没有正常获取到参数，则发送日志信息
            if (IS_IMAGE) {
                captureException('upload image key valid error', {
                    anchor: 'uploadKeyValid',
                    extra: {
                        source,
                        filename: key,
                        signature,
                        policy,
                        size,
                        width,
                        height,
                        message: '图片生成携带高度宽度等信息时出错'
                    }
                })
            }
        }

        // 需转码视频地址特殊处理
        if (isVideo(file) && isTranscoder) {
            key = dir
        }

        return upload({
            action: host,
            filename: 'file', // ali oss 固定file
            file: file.source || file,
            ignoreToken: true,
            data: {
                key,
                OSSAccessKeyId: accessId,
                policy,
                Signature: signature,
                success_action_status: '200'
            },
            onProgress(e) {
                onProgress && onProgress(e)
            },
            onSuccess() {
                onSuccess &&
                    onSuccess({
                        url: `${ossUrlDomain}${key}`
                    })
            },
            onError(e, b) {
                captureException('upload error', {
                    anchor: 'upload',
                    extra: {
                        source: e,
                        filename: key,
                        signature,
                        policy,
                        body: b,
                        expire: moment(expire).format('YYYY-MM-DD HH:mm:ss'),
                        now: moment().format('YYYY-MM-DD HH:mm:ss'),
                        message: '上传失败'
                    }
                })

                onError && onError(new Error('上传失败'))
            }
        })
    } else {
        captureException('upload error', {
            anchor: 'upload',
            extra: {
                now: moment().format('YYYY-MM-DD HH:mm:ss'),
                message: '获取签名失败'
            }
        })

        onError && onError(new Error('上传失败'))
    }
}
